export default {
  pageTitle: '开发者信息'
}
